import dayjs from "dayjs";
import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { UniAnswer } from "../dao/UniAnswer";
import { new_ErrorAlert } from "./ExportManager";
import { HisBasic } from "./HisBasic";
import { A98_ColDefineList, BOO_ColDefineList, COL_上班時間, COL_下班時間, COL_作業編號, COL_公司編號, COL_其它輪班班別, COL_工作班別, COL_性別, COL_是否輪班, COL_曾經從事, COL_目前從事開始月, HisBasicColDefine, HisBasicColDefine_輪班幾班制 } from "./HisBasicColDefine";
import { SpwkMetaData } from "./SpwkMetaData";
import { SpwkMetaTable } from "./SpwkMetaTable";

export class HisBasicParser_基本檔 {

  /**
   * 邏輯說明:
   * - 跑過所有 基本檔 欄位定義
   *    - 一一查找對應的數值
   *    - 如果有數值，則填入
   */
  static __ConvertTo_基本檔(func_code: string, ans: UniAnswer, meta_table: SpwkMetaTable): HisBasic {
    let out_his_basic = new HisBasic();
    let col_def_list = GetColDefList(func_code);

    // (完全依照欄位定義跑一次，確保不會多跑 或 少跑)
    // 有些欄位不是在 HIS_FROM 中定義的 如: 作業編號、公司編號...
    for (const define of col_def_list) {
      // 嘗試依照定義檔，查參考資料填入答案
      HisBasicParser_基本檔.SetHisBasicValue_ByDefine(out_his_basic, define, func_code, ans, meta_table);
    }

    //#region 確保所有基礎檔欄位都有處理到
    // if (done_count != his_basic_meta_list.length) {
    //   throw new_ErrorAlert(`864612 基本檔.部分欄位未處理!!!\n應處理基本檔欄位數:${his_basic_meta_list.length}，成功處理:${done_count}`);
    // }
    //#endregion


    // 確保基本格式正確，否則不知道會匯入哪裡
    if ((out_his_basic.作業編號 == null || out_his_basic.作業編號.trim() === "")) {
      throw new_ErrorAlert(`641616 作業編號 必須填寫 !!! ans.member_guid=${ans.member_guid}`);
    }

    if ((out_his_basic.公司編號 == null || out_his_basic.公司編號.trim() === "")) {
      throw new_ErrorAlert(`641617 公司編號 必須填寫 ans.member_guid=${ans.member_guid}`);
    }

    if ((out_his_basic.檢查日期 == null || out_his_basic.檢查日期.trim() === "")) {
      throw new_ErrorAlert(`641618 檢查日期 必須填寫 ans.member_guid=${ans.member_guid}`);
    }

    if ((out_his_basic.身份證號 == null || out_his_basic.身份證號.trim() === "")) {
      throw new_ErrorAlert(`641619 身份證號 必須填寫 ans.member_guid=${ans.member_guid}`);
    }

    return out_his_basic;
  }


  /** 依照特定規則define 從 ans 或 meta_table 中找答案
  * 
  * @param out_his_basic - 數值會回填於此
  * 
  * @param func_code - 特作編號
  * @param ans - [答案來源] UniAnswer
  * @param meta_table - [答案來源] 中繼表 
 *
 */
  static SetHisBasicValue_ByDefine(out_his_basic: HisBasic, define: HisBasicColDefine, func_code: string, ans: UniAnswer, meta_table: SpwkMetaTable) {

    let val = HisBasicParser_基本檔.FindHisBasicValue_ByDefine(func_code, ans, meta_table, define);

    (out_his_basic as any)[define.getXlsColName()] = (val == null ? "" : val);

  }

  /** 依照定義，查找 基本檔 欄位的數值  
  * 規則: 目前 以 his_code="{key_name}" 代表是 基本檔的欄位 (用大括號包起來的his_code)
  * 
  * 
  *
  */
  static FindHisBasicValue_ByDefine(func_code: string, ans: UniAnswer, meta_table: SpwkMetaTable, define: HisBasicColDefine): string | null {

    if (define.data_type === 'custom') {// 特殊規則填寫 依照 define.col_name 個別處理
      return HisBasicParser_基本檔.FindHisBasicValue_ByCustomRule(func_code, ans, meta_table, define);

    } else if (define.data_type === 'radio') {// 以單選規則處理
      return HisBasicParser_基本檔.FindHisBasicValue_ByRadioRule(meta_table, define);

    } else {// 其他簡單基礎資料格式

      let find_meta = meta_table.FindMetaData_ByHisColName(define.getHisCode());// let find = 中繼檔表格.find(x => x.his_code === "{" + define.col_name + "}");

      if (find_meta == null) {
        return null;
      }

      if (define.data_type === 'string') {

        if (find_meta.rhf_value == null) {
          return "";
        } else {
          return "" + find_meta.rhf_value;
        }

      } else if (define.data_type === 'date') {

        if (find_meta.rhf_value == null || find_meta.rhf_value == "") {
          return "";
        } else {
          return dayjs("" + find_meta.rhf_value).format("YYYY/MM/DD");
        }

      } else if (define.data_type === 'number') {

        if (find_meta.rhf_value == null || find_meta.rhf_value == "") {
          return "";
        } else {
          return "" + find_meta.rhf_value;
        }

      } else {
        let err_msg = "198436 未知的 define.data_type:" + define.data_type + "@" + define.getXlsColName() + " !!!";
        alert(err_msg);
        throw new Error(err_msg);
      }

    }

  }

  /** 使用 Radio 單選規則解碼
  *
  */
  static FindHisBasicValue_ByRadioRule(meta_table: SpwkMetaTable, define: HisBasicColDefine): string | null {

    let find = meta_table.FindMetaData_ByHisColName(define.getHisCode());// 找出題目

    if (find == null) {
      return null;// 連題目都沒找到(可能是這份特作沒有此題)

    } else {
      /** 找出此題的數值 */
      let OptionMetaList: SpwkMetaData[] = meta_table.FilterOptions_ByQuestionGuid(find.question_guid);

      let rhf_value = find.rhf_value ?? "";

      if (rhf_value === "") {
        return "";// 找不到數值
      }

      let find_opt_meta = OptionMetaList.find(x => x.code === rhf_value);

      if (find_opt_meta == null) {
        let err_msg = "16846 找不到對應選項 " + rhf_value + "!!!";
        alert(err_msg);
        throw new Error(err_msg);

      } else {
        return find_opt_meta.his_code;
      }
    }

  }

  /** 客製化規則，依照不同欄位使用不同規則讀取並轉換 */
  static FindHisBasicValue_ByCustomRule(func_code: string, ans: UniAnswer, meta_table: SpwkMetaTable, define: HisBasicColDefine): string | null {

    const key = define.getXlsColName();

    if (key === COL_公司編號) {
      //#region RULE: 從 ans 中查找 公司編號
      return ans.company_tax_id;
      //#endregion

    } else if (key === COL_作業編號) {
      //#region RULE: 直接回傳 作業編號
      return func_code;
      //#endregion

    } else if (key === COL_性別) {
      let his_code = define.getHisCode();//"{目前從事開始日}";
      let find_meta = meta_table.FindMetaData_ByHisColName(his_code);

      if (find_meta == null) {
        throw new_ErrorAlert("必須有meta: " + his_code);
      }

      let rhf_value = find_meta.rhf_value;

      if (rhf_value === "男") {
        return "M";
      } else if (rhf_value === "女") {
        return "F";
      } else if (rhf_value === "") {
        return "";
      } else {
        throw new_ErrorAlert(`4949668 未知的性別 !!! ${rhf_value}`);
      }

    } else if (key === COL_曾經從事) {
      let his_code = define.getHisCode();//"{目前從事開始日}";
      let find_meta = meta_table.FindMetaData_ByHisColName(his_code);

      if (find_meta == null) {
        throw new_ErrorAlert("必須有meta: " + his_code);
      }

      let rhf_value = find_meta.rhf_value;

      if (rhf_value == null || rhf_value === "") {
        return "無";
      } else {
        return rhf_value;
      }

    } else if (key === COL_是否輪班) {

      if (func_code === SpwkUtilV3.FUNC_CODE_A01 || func_code === SpwkUtilV3.FUNC_CODE_A98) {

        let his_radio_value = HisBasicParser_基本檔.FindHisBasicValue_ByRadioRule(meta_table, HisBasicColDefine_輪班幾班制);

        if (his_radio_value == null) {
          throw new_ErrorAlert("66841 應該要有 輪班幾班制 !!!");

        } else {
          if (his_radio_value === '1' || his_radio_value === '') {
            return "N";
          } else {
            return "Y";
          }
        }

      } else {
        return "";// A01 與 A98 不需要輪班資訊
      }

    } else if (key === COL_工作班別) {

      if (func_code === SpwkUtilV3.FUNC_CODE_A98) {

        let his_radio_value = HisBasicParser_基本檔.FindHisBasicValue_ByRadioRule(meta_table, HisBasicColDefine_輪班幾班制);

        if (his_radio_value == null) {
          throw new_ErrorAlert("66841 應該要有 輪班幾班制 !!!");

        } else {
          if (his_radio_value === '1' || his_radio_value === '') {
            return "1";// 固定班別
          } else {
            return "2";// 輪班
          }
        }

      } else {
        throw new_ErrorAlert("43430158 應該只有A98有此項目!!!");
      }

    } else if (key === COL_目前從事開始月) {
      let his_code = define.getHisCode();//"{目前從事開始日}";
      let find_meta = meta_table.FindMetaData_ByHisColName(his_code);

      if (find_meta == null) {
        throw new_ErrorAlert("必須有meta: " + his_code);
      }

      let rhf_value = find_meta.rhf_value;

      if (rhf_value == null || rhf_value === "") {
        return "";
      } else {
        let dt = dayjs(rhf_value);
        let yyymm = ("" + (dt.year() - 1911)).padStart(3, "0") + "" + dt.format("MM");
        return yyymm;
      }

    } else if (key === COL_其它輪班班別) { // A98
      let his_code = define.getHisCode();//"{上班時間}" or {下班時間};
      let find_meta = meta_table.FindMetaData_ByHisColName(his_code);

      if (find_meta == null) {
        throw new_ErrorAlert("A98 應該要有 其它輪班班別!!!");
      }

      let rhf_value = find_meta.rhf_value;

      if (rhf_value == null || rhf_value === "") {
        return "";
      } else {
        if (rhf_value === "其他") {
          return rhf_value;
        } else if (rhf_value === "固定") {
          return "1";
        } else if (rhf_value === "兩班" || rhf_value === "三班" || rhf_value === "四班") {
          return rhf_value;
        } else {
          throw new_ErrorAlert("未知的 其它輪班班別 數值: " + rhf_value + " !!!");
        }

      }



    } else if (key === COL_上班時間 || key === COL_下班時間) {// A98
      let his_code = define.getHisCode();//"{上班時間}" or {下班時間};
      let find_meta = meta_table.FindMetaData_ByHisColName(his_code);

      if (find_meta == null) {
        throw new_ErrorAlert("A98 應該要有 上班時間 與 下班時間!!!");
      }

      let rhf_value = find_meta.rhf_value;

      if (rhf_value == null || rhf_value === "") {
        return "";
      } else {
        let dt = dayjs(rhf_value);
        let AMPM = (dt.hour() >= 12 ? 'PM' : 'AM');
        let hour = dt.hour();
        hour = hour % 12;
        hour = (hour === 0 ? 12 : hour);
        let min = (dt.minute() % 10);
        let re = AMPM + hour;
        if (min !== 0) {
          re += ("." + min);
        }

        return re;
      }

    } else {
      throw new Error(`468743 未知的 custom 規則: ${define.getXlsColName()} !!!`);
    }
  }


}


function GetColDefList(func_code: string) {
  if (func_code === SpwkUtilV3.FUNC_CODE_A98) {
    return A98_ColDefineList;// A98 特殊格式
  } else {
    return BOO_ColDefineList;// 
  }
}

